import React, { useState } from 'react';
// Remove react-helmet-async import - we'll use a simpler approach
import { Helmet } from 'react-helmet';
import valenciaHeightsBg from '../images/projects/valencia-heights-cover.jpeg';
import nightView from '../images/projects/Valencia Heights/night_view.png';
import aerialView from '../images/projects/Valencia Heights/aerial_view.png';
import entrance from '../images/projects/Valencia Heights/entrance.png';
import catEyeView from '../images/projects/Valencia Heights/cateye_view.png';
import leftView from '../images/projects/Valencia Heights/left_view.png';
import rightView from '../images/projects/Valencia Heights/right_view.png';
import swimmingPool from '../images/projects/Valencia Heights/pool.png';
import bathroom from '../images/projects/Valencia Heights/bathroom.png';
import bedroom from '../images/projects/Valencia Heights/bedroom.png';
import dining from '../images/projects/Valencia Heights/dining.png';
import livingRoom from '../images/projects/Valencia Heights/living_room.png';
import kitchen from '../images/projects/Valencia Heights/kitchen.png';
import daycare from '../images/projects/Valencia Heights/daycare.png';
import mosque from '../images/projects/Valencia Heights/mosque.png';
import gym from '../images/projects/Valencia Heights/gym.png';
import elevators from '../images/projects/Valencia Heights/elevators.png';
import corridor from '../images/projects/Valencia Heights/corridor.png';
import reception from '../images/projects/Valencia Heights/reception.png';
import parking from '../images/projects/Valencia Heights/parking.png';
import powderRoom from '../images/projects/Valencia Heights/powder_room.png';

const ValenciaHeights = () => {
  const [showModal, setShowModal] = useState(false);

  // ---------- DATA FROM PDF (pricing tables) ----------
  const studioSingleData = [
    { type: 'STUDIO 13-B', size: 340, total: 5100000, booking: 1275000, monthly: 31875, sixMonth: 223125, poss: 510000 },
    { type: 'STUDIO 14-B', size: 340, total: 5100000, booking: 1275000, monthly: 31875, sixMonth: 223125, poss: 510000 },
    { type: 'STUDIO 19-B', size: 340, total: 5100000, booking: 1275000, monthly: 31875, sixMonth: 223125, poss: 510000 },
    { type: 'STUDIO 20-B', size: 340, total: 5100000, booking: 1275000, monthly: 31875, sixMonth: 223125, poss: 510000 },
    { type: 'SINGLE BED 22-B', size: 400, total: 6000000, booking: 1500000, monthly: 37500, sixMonth: 262500, poss: 600000 },
    { type: 'SINGLE BED 27-B', size: 498, total: 7470000, booking: 1867500, monthly: 46688, sixMonth: 326813, poss: 747000 },
    { type: 'SINGLE BED 24-B', size: 550, total: 8250000, booking: 2062500, monthly: 51563, sixMonth: 360938, poss: 825000 },
  ];

  const singleDoubleTripleData = [
    { type: 'SINGLE BED 25-B', size: 550, total: 8250000, booking: 2062500, monthly: 51563, sixMonth: 360938, poss: 825000 },
    { type: 'SINGLE BED 16-B', size: 560, total: 8400000, booking: 2100000, monthly: 52500, sixMonth: 367500, poss: 840000 },
    { type: 'DOUBLE BED 23-B', size: 1073, total: 16095000, booking: 4023750, monthly: 100594, sixMonth: 704156, poss: 1609500 },
    { type: 'DOUBLE BED 16-B', size: 1073, total: 16095000, booking: 4023750, monthly: 100594, sixMonth: 704156, poss: 1609500 },
    { type: 'TRIPLE BED 15-B', size: 1120, total: 16800000, booking: 4200000, monthly: 105000, sixMonth: 735000, poss: 1680000 },
    { type: 'TRIPLE BED 18-B', size: 1120, total: 16800000, booking: 4200000, monthly: 105000, sixMonth: 735000, poss: 1680000 },
  ];

  const duplexTowerA = [
    { type: 'Duplex Pent House', size: 2790, total: 55800000, booking: 13950000, fourMonth: 2418000, poss: 5580000 },
    { type: 'Duplex Pent House', size: 2270, total: 45400000, booking: 11350000, fourMonth: 1967333, poss: 4540000 },
    { type: 'Duplex Pent House', size: 2634, total: 52680000, booking: 13170000, fourMonth: 2282800, poss: 5268000 },
    { type: 'Duplex Pent House', size: 2290, total: 45800000, booking: 11450000, fourMonth: 1984666, poss: 4580000 },
    { type: 'Duplex Pent House', size: 3444, total: 68880000, booking: 17220000, fourMonth: 2984800, poss: 6888000 },
    { type: 'Duplex Pent House', size: 2742, total: 54840000, booking: 13710000, fourMonth: 2376400, poss: 5484000 },
  ];

  const duplexTowerB = [
    { type: 'Duplex Pent House', size: 3288, total: 65760000, booking: 16440000, fourMonth: 2849600, poss: 6576000 },
    { type: 'Duplex Pent House', size: 3070, total: 61400000, booking: 15350000, fourMonth: 2660666, poss: 6140000 },
    { type: 'Duplex Pent House', size: 3288, total: 65760000, booking: 16440000, fourMonth: 2849600, poss: 6576000 },
    { type: 'Duplex Pent House', size: 3562, total: 71240000, booking: 17810000, fourMonth: 3087066, poss: 7124000 },
    { type: 'Duplex Pent House', size: 2062, total: 41240000, booking: 10310000, fourMonth: 1787066, poss: 4124000 },
    { type: 'Duplex Pent House', size: 2950, total: 59000000, booking: 14750000, fourMonth: 2556666, poss: 5900000 },
  ];

  const formatCurrency = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // Image URLs
  const images = {
    heroBg: valenciaHeightsBg,
    dayView: valenciaHeightsBg,
    nightView: nightView,
    aerialView: aerialView,
    entrance: entrance,
    catEyeView: catEyeView,
    leftView: leftView,
    rightView: rightView,
    swimmingPool: swimmingPool,
    bedroom: bedroom,
    dining: dining,
    livingRoom: livingRoom,
    kitchen: kitchen,
    bathroom: bathroom,
    powderRoom: powderRoom,
    mosque: mosque,
    gym: gym,
    daycare: daycare,
    corridor: corridor,
    reception: reception,
    elevators: elevators,
    parking: parking,
  };

  return (
    <>
      {/* Simple SEO with regular meta tags */}
      <Helmet>
        <title>Valencia Heights - Premium Apartments in FMC B-17 Islamabad</title>
        <meta name="description" content="Valencia Heights offers luxury apartments in FMC B-17 Islamabad. RDA approved, family residential project with studios, 1-3 bed apartments & duplex penthouses." />
        <meta name="keywords" content="Valencia Heights, FMC B-17, Islamabad apartments, luxury housing, RDA approved, duplex penthouses" />
        <link rel="canonical" href="https://valenciaheights.com" />
        <meta property="og:title" content="Valencia Heights - Premium Apartments in FMC B-17 Islamabad" />
        <meta property="og:description" content="Luxury living in Islamabad's prime location. RDA approved, family residential project with world-class amenities." />
        <meta property="og:image" content={valenciaHeightsBg} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Valencia Heights - Premium Apartments in FMC B-17" />
        <meta name="twitter:description" content="Experience luxury living at Valencia Heights, FMC B-17 Islamabad. RDA approved with state-of-the-art amenities." />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
        {/* Hero Section */}
        <section 
          className="relative text-white overflow-hidden min-h-screen flex items-center"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.8) 0%, rgba(30, 58, 95, 0.6) 100%), url(${images.heroBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/30"></div>
          <div className="relative container mx-auto px-6 py-20 md:py-32 flex flex-col items-center text-center z-10">
            <div className="inline-block bg-white/10 backdrop-blur-md text-white text-xs font-semibold px-6 py-2 rounded-full mb-6 tracking-wider uppercase border border-white/20">
              ✦ RDA Approved • FMC B-17 Islamabad ✦
            </div>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold leading-tight drop-shadow-2xl">
              Valencia <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-200">Heights</span>
            </h1>
            <p className="text-xl md:text-3xl text-blue-100 max-w-3xl mt-6 font-light">
              Fully Family Residential Project • Main Boulevard, FMC, B-17
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-5">
              <a 
                href="https://wa.me/923487172565" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-bold py-4 px-10 rounded-full text-lg shadow-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-emerald-500/30"
              >
                <span className="mr-2">📞</span> Book Now
              </a>
              <button 
                onClick={() => setShowModal(true)}
                className="inline-flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-semibold py-4 px-10 rounded-full text-lg border border-white/30 shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <span className="mr-2">📊</span> Payment Plan
              </button>
            </div>
            <div className="mt-8 text-sm text-blue-200/90 flex flex-wrap justify-center gap-x-8 gap-y-3">
              <span className="flex items-center">📍 3 min to B-17 Gate 2</span>
              <span className="flex items-center">📍 1 min to FMC Gate</span>
              <span className="flex items-center">📍 38 min to Airport</span>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="container mx-auto px-6 py-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">✨ Project Highlights</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.dayView} alt="Day View" className="w-full h-64 object-cover" />
              <p className="text-center py-3 font-semibold text-gray-700">Day View</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.nightView} alt="Night View" className="w-full h-64 object-cover" />
              <p className="text-center py-3 font-semibold text-gray-700">Night View</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.aerialView} alt="Aerial View" className="w-full h-64 object-cover" />
              <p className="text-center py-3 font-semibold text-gray-700">Aerial View</p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.entrance} alt="Entrance" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Entrance</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.catEyeView} alt="Cat Eye" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Cat Eye View</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.leftView} alt="Left View" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Left Angle</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.rightView} alt="Right View" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Right Angle</p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.swimmingPool} alt="Pool" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Swimming Pool</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.bedroom} alt="Bedroom" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Bedroom</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.dining} alt="Dining" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Dining</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.livingRoom} alt="Living Room" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Living Room</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.kitchen} alt="Kitchen" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Kitchen</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.bathroom} alt="Bathroom" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Bathroom</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.powderRoom} alt="Powder Room" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Powder Room</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.corridor} alt="Corridor" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Corridor</p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.mosque} alt="Mosque" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Mosque</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.daycare} alt="Daycare" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Daycare</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.gym} alt="Gym" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Gym</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.reception} alt="Reception" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Reception</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.elevators} alt="Elevators" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Elevators</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <img src={images.parking} alt="Parking" className="w-full h-48 object-cover" />
              <p className="text-center py-2 font-semibold text-gray-700 text-sm">Parking</p>
            </div>
          </div>
        </section>

        {/* Apartment Types */}
        <section className="container mx-auto px-6 pb-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">🏢 Apartment Types</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full"></div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6">
            {['Studio Apartment', 'Single Bed', 'Double Bed', 'Triple Bed', 'Duplex Penthouse'].map((type) => (
              <div key={type} className="group bg-white p-8 rounded-2xl shadow-md text-center border border-gray-100 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="text-5xl mb-4 group-hover:scale-110 transition-transform duration-300">🏠</div>
                <div className="font-semibold text-gray-700 group-hover:text-blue-600 transition-colors duration-200">{type}</div>
              </div>
            ))}
          </div>
          <div className="mt-8 text-center text-sm text-gray-500 bg-white/80 backdrop-blur-sm py-3 px-6 rounded-full shadow-sm max-w-md mx-auto">
            * 2nd to 13th floor apartments • 14th-15th floor Duplex Penthouses
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-gradient-to-r from-gray-800 to-gray-900 py-16">
          <div className="container mx-auto px-6 text-center">
            <h3 className="text-3xl font-bold text-white mb-4">Ready to Book Your Dream Apartment?</h3>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
              Contact us today for a personalized consultation and site visit.
            </p>
            <a 
              href="https://wa.me/923487172565" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-bold py-4 px-12 rounded-full text-lg shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <span className="mr-2">📞</span> Contact Sales Team
            </a>
          </div>
        </section>

        {/* Modal - Working scroll */}
        {showModal && (
          <div 
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
            onClick={() => setShowModal(false)}
          >
            <div 
              className="bg-white rounded-2xl shadow-2xl max-w-6xl w-full max-h-[90vh] flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-5 border-b border-gray-200 flex-shrink-0">
                <h3 className="text-2xl font-bold text-gray-800">📋 Payment Plans</h3>
                <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-gray-700 text-3xl">
                  ×
                </button>
              </div>
              
              <div className="p-6 overflow-y-auto flex-1">
                {/* Studio & Single Bed */}
                <div className="mb-8">
                  <h4 className="font-semibold text-gray-800 mb-3">Studio & Single Bed (2nd-13th Floor)</h4>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border">
                      <thead className="bg-gray-800 text-white">
                        <tr>
                          <th className="px-3 py-2 text-left">Type</th>
                          <th className="px-3 py-2 text-left">Size</th>
                          <th className="px-3 py-2 text-left">Total</th>
                          <th className="px-3 py-2 text-left">Booking 25%</th>
                          <th className="px-3 py-2 text-left">Monthly (48)</th>
                          <th className="px-3 py-2 text-left">6-Month (x8)</th>
                          <th className="px-3 py-2 text-left">Possession 10%</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studioSingleData.map((item, i) => (
                          <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="px-3 py-2 border-b">{item.type}</td>
                            <td className="px-3 py-2 border-b">{item.size} sqft</td>
                            <td className="px-3 py-2 border-b font-semibold">PKR {formatCurrency(item.total)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.booking)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.monthly)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.sixMonth)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.poss)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Single Double Triple */}
                <div className="mb-8">
                  <h4 className="font-semibold text-gray-800 mb-3">Single, Double & Triple Bed (2nd-13th Floor)</h4>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border">
                      <thead className="bg-gray-800 text-white">
                        <tr>
                          <th className="px-3 py-2 text-left">Type</th>
                          <th className="px-3 py-2 text-left">Size</th>
                          <th className="px-3 py-2 text-left">Total</th>
                          <th className="px-3 py-2 text-left">Booking 25%</th>
                          <th className="px-3 py-2 text-left">Monthly (48)</th>
                          <th className="px-3 py-2 text-left">6-Month (x8)</th>
                          <th className="px-3 py-2 text-left">Possession 10%</th>
                        </tr>
                      </thead>
                      <tbody>
                        {singleDoubleTripleData.map((item, i) => (
                          <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="px-3 py-2 border-b">{item.type}</td>
                            <td className="px-3 py-2 border-b">{item.size} sqft</td>
                            <td className="px-3 py-2 border-b font-semibold">PKR {formatCurrency(item.total)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.booking)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.monthly)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.sixMonth)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.poss)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Duplex Tower A */}
                <div className="mb-8">
                  <h4 className="font-semibold text-gray-800 mb-3">Duplex Penthouses – Tower A (14th-15th Floor)</h4>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border">
                      <thead className="bg-gray-800 text-white">
                        <tr>
                          <th className="px-3 py-2 text-left">Type</th>
                          <th className="px-3 py-2 text-left">Size</th>
                          <th className="px-3 py-2 text-left">Total</th>
                          <th className="px-3 py-2 text-left">Booking 25%</th>
                          <th className="px-3 py-2 text-left">4-Month (x15)</th>
                          <th className="px-3 py-2 text-left">Possession 10%</th>
                        </tr>
                      </thead>
                      <tbody>
                        {duplexTowerA.map((item, i) => (
                          <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="px-3 py-2 border-b">{item.type}</td>
                            <td className="px-3 py-2 border-b">{item.size} sqft</td>
                            <td className="px-3 py-2 border-b font-semibold">PKR {formatCurrency(item.total)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.booking)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.fourMonth)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.poss)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Duplex Tower B */}
                <div>
                  <h4 className="font-semibold text-gray-800 mb-3">Duplex Penthouses – Tower B (14th-15th Floor)</h4>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border">
                      <thead className="bg-gray-800 text-white">
                        <tr>
                          <th className="px-3 py-2 text-left">Type</th>
                          <th className="px-3 py-2 text-left">Size</th>
                          <th className="px-3 py-2 text-left">Total</th>
                          <th className="px-3 py-2 text-left">Booking 25%</th>
                          <th className="px-3 py-2 text-left">4-Month (x15)</th>
                          <th className="px-3 py-2 text-left">Possession 10%</th>
                        </tr>
                      </thead>
                      <tbody>
                        {duplexTowerB.map((item, i) => (
                          <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="px-3 py-2 border-b">{item.type}</td>
                            <td className="px-3 py-2 border-b">{item.size} sqft</td>
                            <td className="px-3 py-2 border-b font-semibold">PKR {formatCurrency(item.total)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.booking)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.fourMonth)}</td>
                            <td className="px-3 py-2 border-b">PKR {formatCurrency(item.poss)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-4 italic">* Prices in PKR. Installment plans as per brochure.</p>
              </div>
              
              <div className="p-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl flex justify-end flex-shrink-0">
                <button onClick={() => setShowModal(false)} className="bg-gray-800 hover:bg-gray-900 text-white px-8 py-2.5 rounded-lg text-sm font-medium">
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <footer className="bg-gray-900 text-gray-300 py-8">
          <div className="container mx-auto px-4 text-center">
            <p className="font-medium">© 2026 Valencia Heights • FMC B-17 Islamabad • RDA Approved</p>
            <p className="text-sm text-gray-400 mt-2">📍 Plot #9, Main Boulevard, FMC, B-17, Islamabad</p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ValenciaHeights;